export default "__VITE_ASSET__JO2tN4CJ__"